import { defineMessages } from 'react-intl';
export default defineMessages({
    correlationId: {
        id: 'sales.copyCorrelationId.correlationId',
        defaultMessage: 'Correlation Id: {cid}',
    },
});
